export const notFoundRoute = {
  name: 'Page404',
  path: '/404',
  component: () =>
    import(
      /* webpackChunkName: "Page404" */
      '@/views/notFound/Page404.vue'
    ),
}

/**
 * @description https://next.router.vuejs.org/guide/migration/#removed-star-or-catch-all-routes
 */
export const redirectNotFoundRoute = {
  path: '/:pathMatch(.*)*',
  beforeEnter: () => {
    window.location.href = '/404'
  },
}
